import React, {useState} from "react";
import {DatePicker} from 'antd';
import locale from 'antd/es/date-picker/locale/en_US';
import {useTranslation} from "react-i18next";
import dayjs, {Dayjs} from "dayjs";
import {RangePickerProps} from "antd/es/date-picker";

type RangeValue = [Dayjs | null, Dayjs | null] | null;

const {RangePicker} = DatePicker;

interface Props {
  start?: number;
  end?: number;
  onSearch?: (startMinute: number, endMinute: number) => void;
}

const now = dayjs();
const TimeFilter = ({onSearch, start, end}: Props) => {
  const {t} = useTranslation("shipping");
  const [dates, setDates] = useState<RangeValue>([
    start ? now.subtract(start, "minutes") : now.subtract(1, 'day'), end ? now.subtract(end, "minutes") : now
  ]);
  
  const handleChangeDate = (dates: RangeValue) => {
    setDates(dates);
    let start = 0, end = 0;
    if (dates && dates[0] && dates[1]) {
      start = now.diff(dates[0], "minutes");
      end = now.diff(dates[1], "minutes");
    }
    console.log("handleChangeTime", dates, start, end);
    
    !!onSearch && onSearch(start, end);
  };
  
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days after today and today
    return current && current > dayjs()
    .endOf('day');
  };
  
  return (<RangePicker
    showTime
    showNow
    locale={{
      ...locale, lang: {
        ...locale.lang,
        year: "년",
        month: "월",
        dateTimeFormat: "HH:mm",
        shortWeekDays: ["일", "월", "화", "수", "목", "금", "토"],
        shortMonths: [
          "1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월",
        ],
        ok: t("popup.btn.ok"),
      },
    }}
    format={"YYYY-MM-DD HH:mm"}
    value={dates}
    disabledDate={disabledDate}
    onChange={handleChangeDate}
  />);
};

export default TimeFilter;
